// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.value.euler {\n  width: 16%;\n}\ninput.value.euler.alpha,\ninput.value.euler.beta {\n  margin-left: 2%;\n}\n", ""]);
// Exports
module.exports = exports;
